import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryActivityPrediction } from 'api/queries/getActivityPrediction.query';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

export const useFinishDateOverallSummaryProvider = ({
    widgetId,
    globalFilterData,
    localFilters,
    latestVersionId,
    componentKey,
}) => {
    const { isGenerativeAi } = usePinboardWidgetWrapperContext();
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };

    return {
        ui: {
            state: getState({ source }),
            pills: useGetPills(source, widgetId, latestVersionId),
        },
        api: {
            getActivityPrediction: useQueryActivityPrediction(
                getActivityPredictionPayload({ latestVersionId, source, isGenerativeAi, componentKey, widgetId }),
            ),
        },
    };
};

const getActivityPredictionPayload = ({ latestVersionId, source, isGenerativeAi, componentKey, widgetId }) => {
    return {
        versionId: latestVersionId,
        hashCode: source?.milestoneFragnet,
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId),
    };
};

const getState = ({ source }) => {
    return {
        //global
        milestoneFragnet: source?.milestoneFragnet,
    };
};

const useGetPills = (source, widgetId, latestVersionId) => {
    const pillsData = {
        milestoneFragnet: source?.milestoneFragnet,
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        widgetId,
        latestVersionId,
        source: pillsData,
    });

    return pills;
};
